var chunkToChildrenMap = {
	"3": [
		982
	],
	"189": [
		982
	],
	"642": [
		982
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };